mutation CancelDripSequenceForEntity($dripProgressionDeleteInput: DripProgressionDeleteInput!) {
    dripProgressionDelete(input: $dripProgressionDeleteInput) {
        dripProgression {
            id
        }
    }
}
